<!-- themeLogo -->
<!--footer section -->
<footer [class]="class" >
  <div class="light-layout" *ngIf="!isLoggedIn">
    <div class="container">
      <section class="small-section border-section border-top-0">
        <div class="row">
          <div class="col-lg-6">
            <div class="subscribe">
              <div>
                <h4>KNOW IT ALL FIRST!</h4>
                <p>
                  By Signing Up To Our Newsletter You Never Miss Anything from NeoJobz
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <form class="form-inline subscribe-form" [formGroup]="form" (ngSubmit)="createSubscription()"
              target="_blank">
              <div class="form-group mx-sm-3">
                <input type="email" #name name="EMAIL" id="mce-EMAIL" class="form-control" formControlName="email"
                  placeholder="Enter your email" />
              </div>
              <button type="submit" class="btn btn-solid">subscribe</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
  <section class="section-b-space light-layout ">
    <div class="container">
      <div class="row footer-theme partition-f">
        <div class="col-lg-4 col-md-6">
          <div class="footer-title footer-mobile-title">
            <h4>about</h4>
          </div>
          <div class="footer-contant">

            <div class="footer-logo" style="display: flex; flex-direction: row;">
              <div>
                <img [src]="themeLogo" alt="logo" style="width: 6.25rem; height: 5rem;" />
              </div>
              <div style="padding-left: 5%">
                <p>
                  NeoJobz is One-Stop-Solutions e-platform for Employment<br />
                </p>
              </div>
            </div>

            <div class="footer-social">
              <ul>
                <li>
                  <a href="https://www.facebook.com/whiterobein" target="_blank"><i class="fa fa-facebook-square" aria-hidden="true"></i>
                  </a>
                </li>
                <!-- <li>
                                    <a href="javascript:void(0)"><i class="fa fa-google-plus" aria-hidden="true"></i></a>                 
                                </li> -->
                <li>
                  <a href="https://www.linkedin.com/company/whiterobe" target="_blank"><i class="fa fa-linkedin-square" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/Whiterobein" target="_blank"><i class="fab fa-x-twitter" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href=" https://www.instagram.com/whiterobe.in/ " target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href="https://in.pinterest.com/whiterobein/" target="_blank"><i class="fa fa-pinterest-square" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@WhiteRobein/" target="_blank"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
                </li>
                <!-- <li>
                  <a href="https://play.google.com/store/apps/details?id=com.app.whiterobe" target="_blank" ><i class="fa-brands fa-google-play" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href="https://play.google.com/store/apps/details?id=com.app.whiterobe" target="_blank" ><i class="fa-brands fa-app-store" aria-hidden="true"></i></a>
                </li> -->

              </ul>
            </div>
          </div>
         
        </div>
        <div class="col offset-xl-1">
          <div class="sub-title">
            <div class="footer-title">
              <h4>Categories</h4>
            </div>
            <div class="footer-contant">
              <ul>
                <!-- <li><a href="javascript:void(0)">Men & Womens Fellowship</a></li>
                                <li><a href="javascript:void(0)">children Sunday School</a></li>
                                <li><a href="javascript:void(0)"></a>Group Prayers</li>
                                <li><a href="javascript:void(0)"></a>Pasting Prayers</li> -->
                <li (click)="openEmployement()" class="clickable">Trending Jobs</li>
                <li (click)="openProduct()" class="clickable">Pricing</li>
                <li (click)="openHiring()" class="clickable">Immediate Hirings</li>
                <li (click)="openContact()" class="clickable">Contact Us</li>
                <li (click)="openPricing()" class="clickable">Pricing Policy</li>
                <li (click)="openRefund()" class="clickable">Refund Policy </li>
                <li (click)="openCancellation()" class="clickable">Cancellation Policy </li>
                <!-- <li (click)="openShipping()" class="clickable">Shipping Policy</li> -->
                <!-- <li>Matrimony</li> -->
                <!-- <li>E-Tailing</li> -->
                <li>&nbsp;</li>
                <!-- <div style="width: 80%;display:flex;">
                  <div style="width: 40%; cursor: pointer;" >
                    <img class="img-fluid"  src="assets/images/play_store.png"
                      (click)="openPlayStore()">
                </div>
                <div style="width: 40%;">
                    <img class="img-fluid"  src="assets/images/app-store.png"
                    >
                </div>
                </div> -->
                <!-- <li>e-Tailing</li> -->
                
                <!-- <li>Glocal Church Community</li> -->
              </ul>
            </div>
          </div>
         
        </div>
        <div class="col">
          <div class="sub-title">
            <div class="footer-title">
              <h4>Contact Information</h4>
            </div>
            <div class="footer-contant">
              <ul class="contact-list">
                <!-- <li><i class="fa fa-map-marker"></i>
                  Flat 402, Kinetic Pride, 
                  Masjid Banda, Kondapur, Hyderabad - 500084</li> -->
                <li><i class="fa fa-map-marker" style="color: #BF0000;"></i>
                  India, UK, Canada</li>
                <li>
                  <i class="fa fa-phone" style="color: #BF0000;"></i>
                  <a href="tel:+919849848195">+91-70 75 85 5784</a>
                </li>
                <li>
                  <i class="fa fa-envelope-o" style="color: #BF0000;"></i>
                  <a href="mailto:contact@whiterobe.in" style="text-transform: lowercase">contact&#64;whiterobe.in</a>

                  <div class="row">
                    <div class="col-lg-12">&nbsp;</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">&nbsp;</div>
                  </div>

                  <!-- <a (click)="goTo()"><strong>Terms and Conditions</strong></a>
                  <span class="mx-2"></span>
                  <a (click)="goToPrivacy()"><strong>Privacy and Policy</strong></a> -->
                </li>
              
              </ul>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="play-store-div">
                  <div class="play-store-div__images">
                    <img class="img-fluid hover-effect" src="assets/images/play-store.svg" (click)="openPlayStore()">
                  </div>
                  <div class="play-store-div__images" >
                    <img class="img-fluid hover-effect" src="assets/images/app-store.svg" (click)="openPlayStore()">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col">
					<div class="sub-title">
						<div class="footer-title">
						    <h4>store information</h4>
						</div>
						<div class="footer-contant">
						    <ul class="contact-list">
						        <li><i class="fa fa-map-marker"></i>Gethsemane Prayers Demo Store, Demo store
						            India 345-659</li>
						        <li><i class="fa fa-phone"></i>Call Us: 123-456-7898</li>
						        <li><i class="fa fa-envelope-o"></i>Email Us: <a>Support@Fiot.com</a></li>
						        <li><i class="fa fa-fax"></i>Fax: 123456</li>
						    </ul>
						</div>
					</div>
				</div> -->
      </div>
    </div>
  </section>
  <div class="sub-footer">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-12 col-md-6 col-sm-12">
          <div class="footer-end d-flex justify-content-between">
            <!-- <div> -->
            <p class="mb-0">
              <i class="fa fa-copyright" aria-hidden="true"></i>
              2020 - {{ currentYear }} WhiteRobe All Rights Reserved
            </p>
            <!-- </div>
            <div> -->
            <p class="mb-0">
              <a (click)="goTo()" style="cursor: pointer;">Terms and Conditions</a>
              <span class="mx-2">|</span>
              <a (click)="goToPrivacy()" style="cursor: pointer;">Privacy Policy</a>
              <!-- <span class="mx-2">|</span>
                <a ><strong>Refund Policy</strong></a>
                <span class="mx-2">|</span>
                <a ><strong>Disclaimer</strong></a> -->
            </p>
            <!-- </div> -->
          </div>
        </div>
        <!-- <div class="col-xl-6 col-md-6 col-sm-12"> -->
        <!-- <div class="payment-card-bottom">
             <ul>
                      <li>
                        <a>
                          <img src="assets/images/icon/visa.png" alt="">
                        </a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/mastercard.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/paypal.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/american-express.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/discover.png" alt=""></a>
                      </li>
                    </ul>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
  </div>

</footer>
<!--footer section end -->